import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {卸比較商品型} from '@/type/estimates/comparison';
import {卸型} from '@/type/wholesale/wholesale';

export default class 入札確定チェッカー {
  チェック結果: Error[] = [];

  constructor(target: 卸比較商品型[], wholesales: 卸型[]) {
    const 納入価チェック = 納入価(target, wholesales);
    const 納入卸チェック = 納入卸(target);
    this.チェック結果 = 納入価チェック.concat(納入卸チェック);
  }

  hasErrors(): boolean {
    return this.チェック結果.length > 0 ;
  }

  errorMessages(): string[] {
    return this.チェック結果
      .sort((a, b) => a.index - b.index)
      .map((value) => value.message);
  }
}

function ゼロ以上(value: number): boolean {
  return value >= 0;
}

function 納入価(target: 卸比較商品型[], wholesales: 卸型[]): Error[] {
  const errors: Error[] = [];
  target.forEach((item, index): void => {
    item.入札一覧.forEach((value): void => {
      if (!value.納入価) return;
      if (ゼロ以上(value.納入価)) return;
      errors.push(
        {
          index,
          message: `${index + 1}: ${卸名(wholesales, value.卸コード)}の納入価は0より大きな値にして下さい`,
          constraint: '',
          name: '納入価エラー',
        },
      );
    });
  });
  return errors;
}

function 納入卸(target: 卸比較商品型[]): Error[] {
  const errors: Error[] = [];
  target.forEach((item, index): void => {
    if (item.採用卸コード === null) {
      errors.push(
        {
          index,
          message: `${index + 1}: 現納入卸を設定して下さい`,
          constraint: '',
          name: '現納入卸エラー',
        },
      );
    }
  });
  return errors;
}

function 卸名(wholesales: 卸型[], code: string): string {
  const 卸 = wholesales.find((wholesale) => wholesale.卸コード === code);
  if (卸 === undefined) return '';
  return 卸.卸名;
}
